import { Layout } from '@evisort/eds/components/Layout/Layout';
import { Placeholder } from '@evisort/eds/components/Placeholder/Placeholder';
import { defineMessages, useIntl } from 'react-intl';

import { useCurrentUser } from '~/hooks/useCurrentUser';
import { logout } from '~/utils/logout';

import './MaintenancePage.css';

const messages = defineMessages({
  title: {
    id: 'MaintenancePage.title',
    defaultMessage: 'Scheduled Maintenance in Progress',
    description:
      "Title shown in place of the app while the client's workspace is under scheduled maintenance",
  },
  description: {
    id: 'MaintenancePage.description',
    defaultMessage:
      "Your organization's workspace is unavailable while we complete scheduled maintenance. Try again later.",
    description:
      "Explains that the client's workspace is temporarily unavailable during scheduled maintenance",
  },
  reload: {
    id: 'MaintenancePage.reload',
    defaultMessage: 'Reload',
    description:
      'Button that reloads the page to check whether maintenance has finished',
  },
  logOut: {
    id: 'MaintenancePage.logOut',
    defaultMessage: 'Log Out',
    description:
      'Button that logs out of the workspace during scheduled maintenance',
  },
});

function handleReload() {
  window.location.reload();
}

/**
 * Full-page screen shown in place of the app while a client is locked out for
 * its legacy-to-Unified-Fields migration window.
 */
export function MaintenancePage() {
  const intl = useIntl();
  const currentUser = useCurrentUser();
  const reloadLabel = intl.formatMessage(messages.reload);
  const logOutLabel = intl.formatMessage(messages.logOut);

  return (
    <Layout
      align="center"
      className="maintenance-page"
      direction="column"
      justify="center"
    >
      <Placeholder
        actions={[
          {
            label: logOutLabel,
            text: logOutLabel,
            onClick: () => logout(currentUser),
          },
          {
            label: reloadLabel,
            text: reloadLabel,
            variant: 'primary',
            onClick: handleReload,
          },
        ]}
        description={intl.formatMessage(messages.description)}
        illustration="error"
        title={intl.formatMessage(messages.title)}
      />
    </Layout>
  );
}
